

module.exports = __webpack_require__.stylable.create(
    "Section644501485",
    {"classes":{"root":"Section644501485__root","divider":"Section644501485__divider","buttonWrapper":"Section644501485__buttonWrapper","childrenWrapper":"Section644501485__childrenWrapper"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    2,
    "Section644501485",
    null
);
